var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-slider" },
    [
      _c("input", {
        attrs: { type: "range", min: _vm.min, max: _vm.max, step: _vm.step },
        domProps: { value: _vm.value },
        on: {
          input: _vm.handleInput,
          change: _vm.handleChange,
          dblclick: _vm.handleDblclick
        }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "track", style: _vm.trackStyle }),
      _vm._v(" "),
      _vm._l(_vm.pins, function(pin, index) {
        return _c(
          "span",
          {
            key: index,
            staticClass: "pin",
            style: { left: _vm.round(pin.value * 100) + "%" }
          },
          [_vm._v("\n    " + _vm._s(pin.label) + "\n  ")]
        )
      }),
      _vm._v(" "),
      _c("span", { staticClass: "thumb", style: _vm.thumbStyle }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }